import {initialState, initialMutations, initialActions} from "../common_store";
// initialState = JSON.parse(JSON.stringify(initialState));
// initialActions = Object.assign({},initialActions);
// initialMutations = Object.assign({},initialMutations);
let defaultState = {
    url_name: 'appointment/report'
};

defaultState = {...initialState, ...defaultState};
defaultState = JSON.parse(JSON.stringify(defaultState));

const getters = {
    reportLoading: state => state.loading,
};

let actions = {...initialActions};
// actions = JSON.parse(JSON.stringify(actions));
let mutations = {...initialMutations};
// mutations = JSON.parse(JSON.stringify(mutations));

export default {
    namespaced: true,
    state: defaultState,
    getters,
    actions,
    mutations
}
